"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserActivityEnum = void 0;
var UserActivityEnum;
(function (UserActivityEnum) {
    UserActivityEnum["Login"] = "Login";
    UserActivityEnum["MessageSent"] = "MessageSent";
    UserActivityEnum["JobRequestSent"] = "JobRequestSent";
    UserActivityEnum["JobRequestAcceptedByTalent"] = "JobRequestAcceptedByTalent";
    UserActivityEnum["JobGoAheadGivenByClient"] = "JobGoAheadGivenByClient";
    UserActivityEnum["ActiveFindJob"] = "ActiveFindJob";
    UserActivityEnum["ProjectCreated"] = "ProjectCreated";
    UserActivityEnum["CollectionCreated"] = "CollectionCreated";
    UserActivityEnum["ProjectShared"] = "ProjectShared";
    UserActivityEnum["FileSent"] = "FileSent";
    UserActivityEnum["FileUploaded"] = "FileUploaded";
    UserActivityEnum["OriginalFileDownloaded"] = "OriginalFileDownloaded";
    UserActivityEnum["FileConverted"] = "FileConverted";
    UserActivityEnum["VersionNewSend"] = "VersionNewSend";
    UserActivityEnum["PrintOrder"] = "PrintOrder";
    UserActivityEnum["PortfolioCreated"] = "PortfolioCreated";
    UserActivityEnum["EcommerceOrder"] = "EcommerceOrder";
    UserActivityEnum["ProjectRecievedAndViewed"] = "ProjectRecievedAndViewed";
})(UserActivityEnum = exports.UserActivityEnum || (exports.UserActivityEnum = {}));
//# sourceMappingURL=userActivity.js.map